import React from 'react';
import Loading from '../../loadings';
import $ from "jquery";
import Server from '../../../functions/servername';
import MakeDecimalPoint from '../../makedecimalpoints';
import getFormatedDate from '../../../functions/date';
import View from './view';
import { Grid, Button } from 'semantic-ui-react';
import CustomerDetails from '../../others/customerdetails';
import PendingPayment from './pendingpayment';
import Transfer from '../../Accountings/Journal/transfer';

class Statement extends React.Component {

  state = {
    statements: [], fromDate: this.props.fromDate, toDate: this.props.toDate,
    date: null, closingBalance: 0, openingBalance: 0
  }

  componentDidMount() {
    this.getStatements();
  }

  getStatements() {
    let context = this;
    let data = { 'id': context.props.id, 'fromDate': this.state.fromDate, 'toDate': this.state.toDate };
    console.log(data);
    context.setState({ load: true, message: 'Getting Statement!!!'})
    $.ajax({
      type: 'POST', data,
      url: Server() + 'payment/webstatement.php',
      success: function(data) {
        console.log(data)
        let closingBalance = context.props.sendClosingBalance;
        let openingBalance = context.props.sendOpeneingBalance;
        try {
          data = JSON.parse(data);
          data.map((c) => { 
            closingBalance = c.closing_balance; 
            openingBalance = c.opening_balance; 
            c.amount = c.amount * -1; 
          })
          if (!data.length) {
            closingBalance = context.convertIntoNumber(closingBalance);
            openingBalance = context.convertIntoNumber(openingBalance);
            closingBalance = closingBalance * -1;
            openingBalance = openingBalance * -1;
          }
          context.sortDate(data, closingBalance, openingBalance);
        } catch (e) { context.setState({ load: false, closingBalance }) }
      },
      error: function(e) {
        alert('Try again!!');
        context.setState({ load: false });
      }
    });
  }

  sortDate(data, closingBalance, openingBalance) {
    data.sort(function(a,b){
      return new Date(b.timestamp) - new Date(a.timestamp);
    });
    closingBalance = this.convertIntoNumber(closingBalance);
    openingBalance = this.convertIntoNumber(openingBalance);
    this.setState({ statements: data, originalData: data, load: false, closingBalance: (closingBalance * -1), openingBalance: (openingBalance * -1) });
  }

  handleChange = name => event => {
    this.setState({ [name]: event.target.value });
  };

  convertIntoNumber(value) {
    try {
      value = Number(value);
    } catch (e) {
      value = 0;
    }
    return value;
  }

  render() {
    return (
      <div>
        <Loading load={this.state.load} message={this.state.message} />
        <div style={{fontSize: 18}}>
          <CustomerDetails type='quotation' customerId={this.props.id} customerName={this.props.customername} />
        </div>
        <div style={{padding: '1%'}}>
          <div style={{display: 'flex'}}>
            <div>
              From Date<br/>
              <input type="date"  id="date" value={this.state.fromDate} onChange={this.handleChange('fromDate')} />
            </div>
            <div>
              To Date<br/>
              <input type="date"  id="date" value={this.state.toDate} onChange={this.handleChange('toDate')} />
            </div>
            <div>
              <br/>
              <Button onClick={this.getStatements.bind(this)}>Submit</Button>
            </div>
            <div>
              <br/>
              {
                this.props.menuPermission.add ?
                (<Transfer type="Customer" transferControl={"show"} />):''
              }
            </div>
            <div>
              <br/>
              <PendingPayment customerId={this.props.id} getClosingbalance={this.props.getClosingbalance}  />
            </div>
            <div style={{fontSize: 18, paddingTop: '1%', textAlign: 'right', width: '45%'}}>
              <br/>
              <b>{'Closing: '+MakeDecimalPoint((this.convertIntoNumber(this.state.closingBalance)))}</b>
            </div>
          </div>
          <View menuPermission={this.props.menuPermission} id={this.props.id} 
          firsttime={this.state.firsttime} closingBalance={this.state.closingBalance} 
          openingBalance={this.state.openingBalance} data={this.state.statements} 
          from_date={this.state.fromDate} to_date={this.state.toDate} />
        </div>
      </div>
    );
  }
}

export default Statement;
